import SearchSVG from "@design-system/ui-icons/vanilla/Search"
import { createIcon } from "../createIcon"

export const SearchIcon = createIcon(SearchSVG)
